import React from "react";
import { Box } from "@mui/material";
import {
  geometrieScene,
  poserSurLeSol,
  poserObstacle,
  estObstacleVertical,
} from "../../../../frontend/src/utils/mineCartPlacement";
import { imageUrl } from "../../utils/scenarioVariants";

// Même toile que l'AspectRatioContainer du jeu, redimensionnée par CSS.
const W = 1408,
  H = 752;
export default function MineCartPlacementPreview({ config, slot, progress }) {
  const scene = config.layout.find((b) => b.name === "scene");
  if (!scene) return null;
  const sw = (W * scene.wPct) / 100,
    sh = (H * scene.hPct) / 100;
  const g = geometrieScene(sw, sh, {
    ...config,
    // Les motifs procéduraux ne sont pas nécessaires au placement des images.
    motifs: { sol: (p) => p, fond: (p) => p },
  });
  const percent = (r) => ({
    left: `${(r.left / sw) * 100}%`,
    top: `${(r.top / sh) * 100}%`,
    width: `${(r.width / sw) * 100}%`,
    height: `${(r.height / sh) * 100}%`,
  });
  const img = (ill, rect, key, extra = {}) =>
    ill?.source && (
      <Box
        key={key}
        component="img"
        src={imageUrl(ill.source)}
        alt={key}
        sx={{
          position: "absolute",
          ...percent(rect),
          objectFit: "contain",
          ...extra,
        }}
      />
    );
  const bankRow =
    config.obstacleIllustrations?.[Number(slot.split(".")[1]) || 0];
  const kind =
    bankRow?.kind ??
    (slot.startsWith("images.obstacles.")
      ? slot.split(".")[2]
      : config.obstacles[0]);
  const entry = config.images?.obstacles?.[kind];
  const obstacle = bankRow
    ? bankRow.image
    : Array.isArray(entry)
      ? entry[Number(slot.split(".")[3]) || 0]
      : entry;
  const x = g.spawnX + (g.impactX - g.spawnX) * progress;
  const vertical = estObstacleVertical(kind);
  const pose = obstacle && poserObstacle(obstacle, g, kind, bankRow?.heightPct);
  const vehicleTransform = {
    transform: `rotate(${g.penteDeg}deg)`,
    transformOrigin: `${((g.cartX + g.cartW * 0.42) / sw) * 100}% ${(g.cartSolY / sh) * 100}%`,
  };
  // Les coordonnées sont locales à la scène ; le conteneur applique son placement.
  return (
    <Box
      sx={{
        position: "absolute",
        left: `${scene.xPct}%`,
        top: `${scene.yPct}%`,
        width: `${scene.wPct}%`,
        height: `${scene.hPct}%`,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          ...percent({ left: 0, top: g.bandeTop, width: sw, height: g.bandeH }),
          bgcolor: config.palette.sol,
          opacity: 0.6,
          transform: `rotate(${g.penteDeg}deg)`,
          transformOrigin: `${(g.xRefSol / sw) * 100}% 42%`,
        }}
      />
      <Box sx={{ position: "absolute", inset: 0, ...vehicleTransform }}>
        {img(
          config.images?.corps,
          {
            ...poserSurLeSol(
              config.images?.corps || { ratio: 1 },
              g.cartW,
              g.cartSolY,
            ),
            left:
              g.cartX +
              poserSurLeSol(
                config.images?.corps || { ratio: 1 },
                g.cartW,
                g.cartSolY,
              ).left,
          },
          "Véhicule",
        )}
        {config.vehicule.appui.positions.map((p, i) =>
          img(
            config.images?.appui,
            {
              left: g.cartX + g.cartW * p.x - g.appuiW / 2,
              top: g.appuiCY - g.appuiH / 2 + (p.dy || 0) * g.appuiH,
              width: g.appuiW,
              height: g.appuiH,
            },
            `Appui ${i + 1}`,
          ),
        )}
      </Box>
      {obstacle && (
        <Box
          sx={{
            position: "absolute",
            ...percent({
              left: x,
              top: g.obTop + (x - g.xRefSol) * g.tanPente,
              width: g.obW,
              height: g.obH,
            }),
            transform: `rotate(${vertical ? 0 : g.penteDeg}deg)`,
            transformOrigin: "50% 96%",
          }}
        >
          <Box
            component="img"
            src={imageUrl(obstacle.source)}
            alt={kind}
            sx={{
              position: "absolute",
              left: `${(pose.left / g.obW) * 100}%`,
              top: `${(pose.top / g.obH) * 100}%`,
              width: `${(pose.width / g.obW) * 100}%`,
              height: `${(pose.height / g.obH) * 100}%`,
              objectFit: "contain",
            }}
          />
        </Box>
      )}
    </Box>
  );
}
